export { default } from './LinkComponent';
